const orderingRules = {
  conditions: { last: ["conditionsOther"] },
  needTasks: { last: ["needTasksOther"] },
  needLanguages: { first: ["needLanguages00", "needLanguages01"], last: ["needLanguagesOther"] },
  ableConditions: { last: ["otherConditions"] },
  ableTasks: { last: ["otherTasks"] },
  ableLanguages: { first: ["ableLanguages00", "ableLanguages01"], last: ["otherLanguages"] }
};

const labelCollator = new Intl.Collator("en-CA", { sensitivity: "base" });

const pinnedIndex = (names, name) => (names ? names.indexOf(name) : -1);
const compareNames = (a, b) => (a === b ? 0 : a < b ? -1 : 1);

export const orderTypeClassSetFields = (setName, fields) => {
  const rule = orderingRules[setName];
  const ordered = fields.slice();
  if (!rule) return ordered;

  return ordered.sort((a, b) => {
    const aFirst = pinnedIndex(rule.first, a.name);
    const bFirst = pinnedIndex(rule.first, b.name);
    if (aFirst !== -1 || bFirst !== -1) {
      if (aFirst !== -1 && bFirst !== -1) return aFirst - bFirst;
      return aFirst !== -1 ? -1 : 1;
    }

    const aLast = pinnedIndex(rule.last, a.name);
    const bLast = pinnedIndex(rule.last, b.name);
    if (aLast !== -1 || bLast !== -1) {
      if (aLast !== -1 && bLast !== -1) return aLast - bLast;
      return aLast !== -1 ? 1 : -1;
    }

    const labelComparison = labelCollator.compare(String(a.placeholder || ""), String(b.placeholder || ""));
    return labelComparison || compareNames(a.name, b.name);
  });
};
